import { FC } from 'react';
import StateBadgeAvisoObra from './Chips/StateBadgeAvisoObra';
import DataTable from '../../../components/DataTable/DataTable';
import { useTranslation } from 'react-i18next';

interface AvisoObraGridProps {
    avisos: any;
    filters: any;
    setFilters: any;
    isFetching: boolean;
    onSelectRow?: (event: React.MouseEvent<HTMLElement>, item: any) => void;
}

const isFechaVencida = (fechaFinStr: string): boolean => {
    if (!fechaFinStr) return false;
    const [dd, mm, yyyy] = fechaFinStr.split('/');
    const fechaFin = new Date(+yyyy, +mm - 1, +dd);
    return fechaFin < new Date();
};

const AvisoObraGrid: FC<AvisoObraGridProps> = ({
    avisos,
    filters,
    setFilters,
    isFetching,
    onSelectRow
}) => {
    const { t } = useTranslation('avisoObra');

    const columnTitles = [
        t('table.columns.nroObra'),
        t('table.columns.direccion'),
        t('table.columns.localidad'),
        t('table.columns.provincia'),
        t('table.columns.programa'),
        t('table.columns.tipoObra'),
        t('table.columns.inicio'),
        t('table.columns.fin'),
        t('table.columns.estado'),
        t('table.columns.fechaAlta'),
        t('table.columns.acciones')
    ];
    const columnWidths = ['5%', '20%', '10%', '10%', '10%', '10%', '5%', '10%', '5%'];

    return (
        <DataTable
            columnTitles={columnTitles}
            columnWidths={columnWidths}
            items={avisos}
            filters={filters}
            setFilters={setFilters}
            onSelectRow={() => {}}
            selectedItemFromAction={null}
            menuOpen={false}
            isFetching={isFetching}
            noPaginated={false}
            headers={[
                { type: 'data', upperLabel: (item: any) => item?.nroObra || '-' },
                { type: 'data', upperLabel: (item: any) => item?.direccion || '-' },
                { type: 'data', upperLabel: (item: any) => item?.localidad || '-' },
                { type: 'data', upperLabel: (item: any) => item?.provincia || '-' },
                { type: 'data', upperLabel: (item: any) => item?.programa || '-' },
                { type: 'data', upperLabel: (item: any) => item?.tipoObra || '-' },
                { type: 'data', upperLabel: (item: any) => item?.fechaInicio || '-' },
                {
                    type: 'data',
                    upperLabel: (item: any) => (
                        <span
                            style={{
                                color: isFechaVencida(item?.fechaFin) ? '#D32F2F' : 'inherit',
                                fontWeight: isFechaVencida(item?.fechaFin) ? 500 : 400
                            }}
                        >
                            {item?.fechaFin || '-'}
                        </span>
                    )
                },
                {
                    type: 'data',
                    upperLabel: (item: any) => (
                        <StateBadgeAvisoObra hideIcon state={item.idEstado} />
                    )
                },
                { type: 'data', upperLabel: (item: any) => item?.fechaAlta || '-' },
                { type: 'action', onClick: (event: any, item: any) => onSelectRow?.(event, item) }
            ]}
        />
    );
};

export default AvisoObraGrid;
